import React from 'react';
import HomeScreen from "../../homescreen/homescreen";
import LoadingComponent from "../../../components/Loading";
import ErrorMessage from "../../../components/ErrorMessage";
import Service from "../../../service/service";
import SuccessMessage from "../../../components/SuccessMessage";


class Login extends HomeScreen {

    loginInfo = {
        username: '',
        password: ''
    }
    state = {
        loginInfo: this.loginInfo,
        loading: false,
        errorMessage: null,
        success: false,
        alreadyLogged: false
    }

    service = new Service();

    getScreenName() {
        return 'Login';
    }

    componentDidMount() {
        if (this.service.getToken()) {
            this.state.alreadyLogged = true;
            this.state.loading = false;
            this.setState(this.state);
        }
    }

    handleChange = (event) => {
        this.loginInfo[event.target.name] = event.target.value;
        this.setState(this.loginInfo);
    };

    validateLogin = () => {
        const {username, password} = this.loginInfo;
        if (username && username.length > 4 && password && password.length > 4) {
            return true;
        }
        return false;
    };

    login = () => {
        if (!this.validateLogin()) {
            this.state.errorMessage = 'User and password should have at least 5 characters';
            this.setState(this.state);
            return;
        }
        this.state.loading = true;
        this.setState(this.state);

        this.service.login(this.loginInfo)
            .then(response => {
                const data = response.data;
                console.debug(response);
                this.state.loading = false;
                this.state.success = true;
                this.setState(this.state);
                this.service.storeTokenInfo(data);
                this.service.storeUserInfo(data.user);
            })
            .catch(error => {
                console.debug(error);
                this.state.errorMessage = 'User or password are incorrect. Please, check them and try again.';
                this.state.loading = false;
                this.setState(this.state);
            });
    };

    logout = () => {
        this.service.logout();
        this.state.alreadyLogged = false;
        this.setState(this.state);
    };

    renderHomeContent() {
        const {errorMessage, loading, success, alreadyLogged} = this.state;
        const buttonClass = loading ? 'myButton myButtonDisabled' : 'myButton myButtonActive';

        if (alreadyLogged) {
            return this.renderAlreadyLoggingScreen();
        }

        if (success) {
            return this.renderLoggingSuccess();
        }

        return (
            <div>
                <p className='sectionDescription'>If you have any question, feedback or just want to say hi, complete the following form.</p>
                <div className='formContainer'>
                    <div>
                        <label>Username:</label>
                        <input type='text'
                               name='username'
                               placeholder='Username'
                               value={this.loginInfo.username}
                               onChange={this.handleChange} disabled={loading} />
                    </div>

                    <div>
                        <label>Password:</label>
                        <input type='password'
                               name='password'
                               placeholder='Password'
                               value={this.loginInfo.password}
                               onChange={this.handleChange} disabled={loading} />
                    </div>

                    <div style={{textAlign: 'end'}}>
                        <p className='sectionDescription'>If you forgot your password, <a href='/requestPasswordReset'>you can reset it here</a></p>
                    </div>

                    <LoadingComponent isLoading={loading} />

                    <ErrorMessage errorMessage={errorMessage} type='warning'/>

                </div>

                <div className='buttonContainer'>
                    <div className={buttonClass} onClick={this.login}>Login</div>
                </div>
            </div>
        );
    }

    renderAlreadyLoggingScreen = () => {
        return (
            <div>
                <p className='sectionDescription'>You are already logged in.</p>
                <p className='sectionDescription'>If you want to sign up, you will need to sign out first.</p>
                <p className='sectionDescription'>Otherwise, you can check your details <a href='/user_info'>in this link</a>.</p>

                <div className='buttonContainer'>
                    <div className='myButton myButtonActive' onClick={this.logout}>Sign out</div>
                </div>
            </div>

        );
    };

    renderLoggingSuccess = () => {
        return (
            <SuccessMessage renderFunc={this.renderSuccessMsg}/>
        );
    };

    renderSuccessMsg = () => {
        return (
            <div>
                <p>You have been logged successfully. You'll be redirected soon.</p>
                <p>If you haven't, please visit the <b className='sectionDescription'><a href='/user_info'>following link</a></b></p>
            </div>
        );
    };

}

export default Login;


// WEBPACK FOOTER //
// ./src/screens/access/login/index.js